type ManageSeatsLinkProps = {
  onClick: () => void;
  /** Resolved label — pulled from `group_subscriptions.card.manage_seats` by the host. */
  label?: string;
};

/**
 * Tiny inline link that opens the Manage Seats modal from anywhere that
 * surfaces "X seats remaining" — GroupCard (collapsed + expanded) and the
 * invite modals. Same styling everywhere so the affordance is recognizable
 * across surfaces.
 */
export function ManageSeatsLink({ onClick, label = 'Manage seats' }: ManageSeatsLinkProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="font-medium text-wt-primary hover:underline focus:outline-none focus-visible:underline"
    >
      {label}
    </button>
  );
}
